import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import HomeSolutionsCards from './Cards';
import { sectionsRefer } from '@/enums/sectionsRefer';

export default function HomeSolutions() {
  const { t } = useTranslation('common');

  return (
    <div
      className={styles.container}
      data-theme="dark"
      id={sectionsRefer.solutions}
    >
      <div className={styles.container__content}>
        <div className={styles.container__content__heading}>
          {t('solutions__heading')}
        </div>
        <div className={styles.container__content__description}>
          {t('solutions__description')}
        </div>
        <div className={styles.container__content__cards}>
          <HomeSolutionsCards />
        </div>
      </div>
    </div>
  );
}
